import React from "react";

const colorMap = {
  blue: { bg: "#2196f3", text: "#fff" },
  green: { bg: "#4caf50", text: "#fff" },
  orange: { bg: "#ff9800", text: "#fff" },
  yellow: { bg: "#ffeb3b", text: "#333" },
  red: { bg: "#f44336", text: "#fff" },
  purple: { bg: "#9c27b0", text: "#fff" },
  gray: { bg: "#6c757d", text: "#fff" },
};

export default function StatusCardWidget({
  title,
  value,
  unit,
  color = "green",
  icon,
  subtitle
}) {
  const colorStyle = colorMap[color] || colorMap.green;

  return (
    <div
      style={{
        ...styles.card,
        backgroundColor: colorStyle.bg,
        color: colorStyle.text,
      }}
    >
      {icon && <span style={styles.icon}>{icon}</span>}
      <span style={styles.title}>{title}</span>
      <span style={styles.value}>
        {value}
        {unit && <span style={styles.unit}>{unit}</span>}
      </span>
    </div>
  );
}

const styles = {
  card: {
    padding: "0px 6px",
    borderRadius: "4px",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    overflow: "hidden",
  },
  icon: {
    fontSize: "14px",
    flexShrink: 0,
  },
  title: {
    fontSize: "11px",
    opacity: 0.9,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    whiteSpace: "nowrap",
  },
  value: {
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: 1,
    marginLeft: "auto",
    whiteSpace: "nowrap",
  },
  unit: {
    fontSize: "11px",
    marginLeft: "2px",
    fontWeight: "normal",
  },
};
